// Applies the saved light/dark theme as soon as the app shell loads.
const KEY = 'dispatch-theme';

export function getTheme() {
  try { return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch (e) { return 'light'; }
}

export function setTheme(t) {
  try { localStorage.setItem(KEY, t); } catch (e) { /* ignore */ }
  document.documentElement.setAttribute('data-theme', t);
}

setTheme(getTheme());
